// Define the custom element class
class SearchForm extends HTMLElement {
  constructor() {
    super();
    // Elements will be initialized in connectedCallback instead
  }

  connectedCallback() {
    // Initialize only once
    if (this._initialized) return;
    this._initialized = true;

    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.searchbutton = this.querySelector('.search__button');
    this.form = this;
    
    // Find elements relative to the component
    this.resultsContainer = this.form.querySelector('[data-live-search-results]');
    this.placeholderContainer = this.form.querySelector('[data-live-search-placeholder]');
    this.flydownContainer = this.querySelector('.search-flydown');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener('input', debounce(this.onChange.bind(this), 300));
    }
  }

  disconnectedCallback() {
    // Clean up event listeners
    if (this.input) {
      this.input.form.removeEventListener('reset', this.onFormReset.bind(this));
      this.input.removeEventListener('input', debounce(this.onChange.bind(this), 300));
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  async onChange(event) {
    this.toggleResetButton();
    
    const searchTerm = event.target.value.trim();
    
    if (!searchTerm.length) {
      this.hideResults();
      this.showPlaceholder();
      return;
    }
    
    try {
const wildcardSearchTerm = searchTerm.split(/\s+/).map(term => `${term}*`).join(' ');
const response = await fetch(`/search?q=${encodeURIComponent(wildcardSearchTerm)}&view=header&type=product,article,page`);
      if (!response.ok) throw new Error(response.status);
      
      const data = await response.json();
      
      if (data.products || data.content) {
        this.resultsContainer.innerHTML = this.createResultsHTML(data);
        this.hidePlaceholder();
        this.showResults();
        this.initcutomeCode();
      } else {
        this.resultsContainer.innerHTML = this.createNoResultsHTML(searchTerm);
        this.hidePlaceholder();
        this.initcutomeCode();
        this.showResults();
      }
    } catch (error) {
      console.error('Search error:', error);
      this.hideResults();
    }
  }

  createResultsHTML(data) {
    let productsHTML = '';
    let contentHTML = '';
    
    // Create products HTML
    if (data.products && data.products.length > 0) {
      productsHTML = `
        <div class="search-flydown--product-items">
          ${data.products.map(product => this.createProductHTML(product)).join('')}
        </div>
      `;
    }
    
    // Create content (pages/posts) HTML
    if (data.content && data.content.length > 0) {
      contentHTML = `
        <div class="search-flydown--content-items">
          <h5 class="search-flydown--content-title">Pages &amp; Posts</h5>
          <ul class="search-flydown--content-items-list">
            ${data.content.map(item => this.createContentHTML(item)).join('')}
          </ul>
        </div>
      `;
    }
    
    // Footer with view all link
    const footerHTML = `
      <div class="search-flydown--footer">
        <a class="search-flydown--continue" href="/search?q=${encodeURIComponent(data.terms)}*&type=article,page,product">
          View all results
        </a>
      </div>
    `;
    
    return productsHTML + contentHTML + footerHTML;
  }

  createProductHTML(product) {
    const price = this.formatPrice(product.price.price);
    const comparePrice = product.price.compare_at_price ? this.formatPrice(product.price.compare_at_price) : null;
    const onSale = product.on_sale ? 'search-flydown--product-price-has-sale' : '';
    
    return `
      <a class="search-flydown--product" href="${product.url}">
        <div class="search-flydown--product-image">
          ${product.image}
        </div>
        <div class="search-flydown--product-text">
          <span class="search-flydown--product-title">${product.title}</span>
          <span class="search-flydown--product-price ${onSale}">
            <span class="search-flydown--product-price--main">
<span class="money">${price}</span>
            </span>
          </span>
          ${product.swatch_count ? `<span class="search-flydown--product-swatch-count">${product.swatch_count}</span>` : ''}
        </div>
      </a>
    `;
  }

  createContentHTML(item) {
    return `
      <li class="search-flydown--content-item">
        <a href="${item.url}">${item.title}</a>
      </li>
    `;
  }

  createNoResultsHTML(term) {
    return `
      <div class="search-flydown--no-results">
        <p>No results found for "${term}"</p>
      </div>
    `;
  }

formatPrice(price) {
  const amount = (price / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  const countryCode = window.Shopify && Shopify.country ? Shopify.country : 'US';
  const symbolMap = {
    IN: '₹',
    US: '$',
    CA: 'CA$',
    GB: '£',
    EU: '€',
    JP: '¥',
    AU: 'A$',
    SG: 'S$',
    NZ: 'NZ$',
    KR: '₩'
  };
  
  const symbol = symbolMap[countryCode] || '$';
  return `${symbol}${amount}`;
}


  initcutomeCode() {    
  const continueLink = document.querySelector('.search-modal__form .search.search-modal__form .search-flydown--footer a');
  const searchButton = this.querySelector('.search__button');
    const searchForm = document.querySelector('.search-modal__form form');

  if (searchButton && continueLink) {
    searchButton.addEventListener('click', (e) => {
      e.preventDefault(); // optional: prevents default behavior
      continueLink.click();
    });
  } 
        if (searchForm) {
      searchForm.addEventListener('submit', (e) => {
        // e.preventDefault(); // Optional: prevent default if needed
        continueLink.click();
      });
    }
  else {
    console.log('Element(s) not found:', { searchButton, continueLink });
  }
  }
  showResults() {
    this.resultsContainer.classList.add('visible');
  }

  hideResults() {
    this.resultsContainer.classList.remove('visible');
  }

  showPlaceholder() {
    //this.placeholderContainer.style.display = 'block';
  }

  hidePlaceholder() {
    //this.placeholderContainer.style.display = 'none';
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
      this.hideResults();
      this.showPlaceholder();
    }
  }
}

// Define the custom element
if (!customElements.get('search-form')) {
  customElements.define('search-form', SearchForm);
}

// Debounce function with cleanup capability
function debounce(fn, wait) {
  let timeoutId;
  const debounced = function(...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), wait);
  };
  
  debounced.cancel = () => clearTimeout(timeoutId);
  return debounced;
}


